export default __webpack_public_path__ + "static/smoke2-9c2c1d2223a0baa63b068d018254ba74.png";